import { createAction } from 'redux-actions'

export const types = {
    ASSIGN_MAP_SETTINGS: 'map/ASSIGN_MAP_SETTINGS',
    GENERATE_MAP: 'map/GENERATE_MAP',
    POPULATE_MAP_DATA: 'map/POPULATE_MAP_DATA',
}

export const actions = {
    assignMapSettings: createAction<MapSettingsDto>(types.ASSIGN_MAP_SETTINGS),
    generateMap: createAction<GenerateMapPayload>(types.GENERATE_MAP),
    populateMapData: createAction<MapDataItem[]>(types.POPULATE_MAP_DATA),
}
